











































































































import Vue from "vue";

import Loading from "../../components/general/Loading.vue";

import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";

import TextView from "../../components/controls/TextView.vue";

export default Vue.extend({
  name: "AppFrame",
  components: {
    Loading,
    TextView,
  },
  props: {
    hideLogo: Boolean,
    hideTitle: Boolean,
    loginscreen: Boolean,
    hidelogout: Boolean,
    blackIcons: Boolean,
    title: String,
    loadingIndicator: Boolean,
    appFrameButtons: Object,
    hideversion: Boolean,
    hideImprint: Boolean,
    footerContent: String,
    cartAmount: Number,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      reloadDateTime: "" as string,
      reloadDisabled: false as boolean,
      clickedButton: null as object | null,
    };
  },
  methods: {
    toggleNav: function () {
      this.$emit("toggleSidebar");
    },

    back: function () {
      let d = DateFormatter.formatISODateTime(new Date());
      this.clickedButton = { back: d };
      this.buttonClicked();
    },

    overview: function () {
      let d = DateFormatter.formatISODateTime(new Date());
      this.clickedButton = { overview: d };
      this.buttonClicked();
    },

    reload: function () {
      this.reloadDateTime = DateFormatter.formatISODateTime(new Date());
      this.clickedButton = { reload: this.reloadDateTime };
      this.buttonClicked();
      this.reloadTimeout();
    },

    reloadTimeout() {
      this.reloadDisabled = true;

      setTimeout(() => (this.reloadDisabled = false), 3000);
    },

    account: function () {
      let d = DateFormatter.formatISODateTime(new Date());
      this.clickedButton = { account: d };
      this.buttonClicked();
    },

    cart: function () {
      let d = DateFormatter.formatISODateTime(new Date());
      this.clickedButton = { cart: d };
      this.buttonClicked();
    },

    logout: function () {
      window.sessionStorage.clear();
      window.localStorage.clear();
      location.reload();
    },

    buttonClicked() {
      this.$emit("appFrameButtonClicked", this.clickedButton);
    },
  },
});
